<template>
  <v-btn outlined color="success" @click="exportExcel">
    <v-icon left>mdi-file-excel</v-icon>
    Xuất Excel
  </v-btn>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { getHeaders } from './utils'
import utils from '@/plugins/utils'
export default {
  computed: {
    ...mapState('salaryHead', ['router', 'searchParams', 'isSubFee'])
  },
  methods: {
    ...mapActions('salaryHead', ['fetchHeadsIndependent']),
    async exportExcel() {
      this.$loading.active = true
      try {
        let headers = getHeaders(this.router, this.isSubFee)
        let excelHeader = headers.map(({ text, value }) => ({ text, value }))
        excelHeader = excelHeader.filter(excel => excel.value !== 'action')
        const params = { category: this.router, _sort: 'createdAt:desc', _limit: -1 }
        if (this.isSubFee) params['type'] = this.isSubFee ? 'sub' : 'sum'
        const data = await this.fetchHeadsIndependent(params)
        const dataParse = JSON.parse(JSON.stringify(data))
        const dataConvert = dataParse.map(item => {
          if (this.router === 'adjust') item.type = item.type === 'sum' ? 'Thưởng' : 'Phạt'
          return item
        })
        utils.exportExcel(dataConvert, excelHeader, `Danh sách ${this.$route.meta.title}`)
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
